import { getResponsiveProp, rem, responsive } from '../helpers';
export function responsiveRadiusStyle(props) {
  var theme = props.theme;
  return responsive(theme.sanity.media, getResponsiveProp(props.radius).map(function (radiusIndex) {
    return {
      borderRadius: rem(theme.sanity.radius[radiusIndex])
    };
  }));
}